import { Outlet } from "react-router-dom";
import { AppFooter } from "@/components/AppFooter";

export function AppFooterLayout() {
  return (
    <div className="flex min-h-dvh flex-col bg-background">
      <div className="flex-1">
        <Outlet />
      </div>
      <AppFooter />
    </div>
  );
}